import io from 'socket.io-client';
import router from "./router";
import { Notification } from "@totalflow4/tfelement-ui";

const socket = io(location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: ''), {
  autoConnect: false,
  transports: ['websocket'],
  path: '/api/notifications/socket.io',
  query: {
    token: 'Bearer ' + sessionStorage.getItem('token'),
  },
});

socket.on('connect', () => {
  console.log('connect sockets')
});

socket.on('disconnect', () => {
  console.log('disconnect sockets', socket);
  // check page
  // setTimeout(() => {
  //   const duration = router.history.current.name === 'login' ? 2000 : 5000;
  //   notificationDisc("Logout", "Success", "error", duration);
    // if (router.history.current.name !== 'login') {
    //   router.push({path: '/login'})
    // }
  // }, 500)
});

function notificationDisc(title, message, type, duration) {
  Notification({
    title: title,
    message: message,
    type: type,
    duration: duration || 5000
  });
}

export default socket
